import React, { Component } from 'react';
import * as Common from '../../helpers/Common';
import * as Config from '../../config/Config';
import * as User from '../../helpers/User';
import Flowplayer from '../../components/Flowplayer';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getNewPost} from '../../actions/newPostAction';
const $= window.$;

class Mylibrary extends Component {
	constructor(props) {
		super(props);
        this.state={

        	leftnav : [],
			rightnav : [],
			contentmsg:'Loading...',
        	id : '',
        	video:'',
        	catvid : 'Category',
        	catdown : 'Video Library',
        	typeshow : 'category',
        	catvidimg : 'video-cam-icon.png',
        	show : 'show',
        	local : '',
        };

        this.getLibrary = this.getLibrary.bind(this);
        this.getSublists = this.getSublists.bind(this);
        this.getRightlst = this.getRightlst.bind(this);
        this.updateViews = this.updateViews.bind(this);

	}
	getMedia(file){

		let trackData={

            compseq_id: '',
            lroom_id: '',
            divider_id:'',
            learner_id:User.UserId(),        
            dlr_id:'',
			compo_type:'my_library'
		};

		let play = "";
		let domain ='';
		if(this.state.local == ""){
			domain = Config.rootDomainUrl+'admin/library_files/';
		}
		else{
			domain = this.state.local+'library_files/';
		}
		if(file){
			let filename = file;
			// let file_type = filename.substr(-3);
			let file_type = filename.split('.').pop();
			if(file_type == 'mp4' || file_type == 'MP4'){
				let new_file = domain+file;


				let video_playlist={
					splash:true,
					share:false,
					ratio: 9/16,
					clip:{
					  sources: [
							{
								type: "video/"+file_type,
								src:new_file
							}
						]
					}
				};
			
				
				play = <Flowplayer key={Date.now()}  playlist={video_playlist} trackData={trackData} />;
			}
		}
		return play;
	}
	getContent(content){
		Common.message('',content,'library');
	}

	updateViews(post_id){
		let learnerID = Common.getUserData("id", true);
		fetch(Config.domainUrl+'left/update-newpost', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,post_id:post_id,type:'library'
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	
               	if(responseJson.status != 0){
               		setTimeout(() => {
						this.props.getNewPost();
			          }, 5000);        
               	}



   		 });
	}

	downFiles(file){
		const {usableType}=this.props;
		let domain = Config.domainUrl+'download/admin/';
		let file_path = domain+file;

		 if(usableType == 'mobileapp'){
		    // document.location=file_path;      
			window.location.href = file_path
		 } 
		  else{
			 // window.location.href = file_path;
				window.open(file_path, '_blank');
			 
		  }
	}

	getFiles(file){
		
		let domain = Config.rootDomainUrl+'admin/library_files/';

		let trackData={

            compseq_id: '',
            lroom_id: '',
            divider_id:'',
            learner_id:User.UserId(),        
            dlr_id:'',
			compo_type:'my_library'
		};
		
		if(file){
			let filename = file;
			//let file_type = filename.substr(-3);
			let file_type = filename.split('.').pop();
			if(file_type == 'mp4' || file_type == 'MP4'){
				let new_file = domain+file;

				let video_playlist={
					share:false,
					ratio: 9/16,
					clip:{
					  sources: [
							{
							type: "video/"+file_type,
							src:new_file
							}
						]
					}
				};
			
				this.setState({
					video : <Flowplayer  playlist={video_playlist} trackData={trackData} />
				});
			}
			else{
				this.setState({
					video : ''
				})
				let file_path = domain+file;
				window.open(file_path, '_blank');
				
			}
		}

	}

	getSublists(e){
           var checkElement = $(e.target).parent();
			var gw_nav = $('.gw-nav');
            gw_nav.find('li').removeClass('active');
            $('.gw-nav > li > ul > li').removeClass('active');


            var ulDom = checkElement.find('.library_submenu')[0];
            // alert(ulDom);
            if (ulDom == undefined) {
                checkElement.addClass('active');
                $('.gw-nav').find('li').find('ul:visible').slideUp();
                return;
            }
            if (checkElement.css('display') != 'block') {
            	// $(".library_submenu").css('display','block');
                gw_nav.find('li').find('ul:visible').slideUp();
                gw_nav.find('li.init-arrow-up').removeClass('init-arrow-up').addClass('arrow-down');
                gw_nav.find('li.arrow-up').removeClass('arrow-up').addClass('arrow-down');
                checkElement.removeClass('init-arrow-down');
                checkElement.removeClass('arrow-down');
                checkElement.addClass('arrow-up');
                checkElement.addClass('active');
                checkElement.find('ul').slideDown(300);
            } else {
                checkElement.removeClass('init-arrow-up');
                checkElement.removeClass('arrow-up');
                checkElement.removeClass('active');
                checkElement.addClass('arrow-down');
                checkElement.find('ul').slideUp(300);

            }
	}
	getRightlst(subcat_id){
		let old_id = this.state.id;
		$("#"+old_id).css('display','none');
		$("#"+subcat_id).css('display','block');
		this.setState({
			id : subcat_id,
			video :''
		})
		//right side scroll bar
		let scrollbar = $('#right_scrollof_'+subcat_id);
		if(scrollbar.height()>500)
		{
			$('.semana-scroll-innerr-right_'+subcat_id).tinyscrollbar();
			$('.semana-scroll-innerr-right_'+subcat_id+' .scrollbar').show();	
		}	

		// let scrollbar = $('.library_cat_right #'+subcat_id+' .semana-scroll-innerr');
		// scrollbar.tinyscrollbar();


		
		// let scrollbar_data = scrollbar.data("plugin_tinyscrollbar");
		// scrollbar_data.update();
		
		
	}

	getTabs(){

		// let scrollbar99 = $('#semana-scroll-inner4');
		 
 		//scrollbar99.tinyscrollbar();

 		// let scrollbar = $('#semana-scroll-innerr');
 		// scrollbar.tinyscrollbar();


        $('.gw-nav > li > ul > li > a').click(function () {
            $(this).parent().parent().parent().removeClass('active');
            $('.gw-nav > li > ul > li').removeClass('active');
            $(this).parent().addClass('active')


        });


	}

	getLibrary(type){

		Common.downTabClose();
		//alert(type);
		let learnerID = Common.getUserData("id", true);
    	let productID = Common.getUserData("productID", true);
    	let pinID = Common.getUserData("pinID", true);
    	//alert(pinID);
    	Common.reactLoader("show", "Please wait...");
		fetch(Config.domainUrl+'resources/get-library', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },

                  body: JSON.stringify({
                    learner_id:learnerID,product:productID,type:type,pin:pinID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	Common.reactLoader("hide");
               	//alert(JSON.stringify(responseJson));
               	//alert(responseJson.type.catvid);
               	if(responseJson.status != 0){
					this.setState({
	                   leftnav : responseJson.lib_left,
	                   rightnav : responseJson.lib_right,
	                   typeshow : responseJson.type.typeshow,
	                   catvid : responseJson.type.catvid,
	                   catdown : responseJson.type.catdown,
	                   catvidimg : responseJson.type.catvidimg,
	                   show : responseJson.type.show,
					   local : responseJson.type.local,
					   contentmsg:(responseJson.lib_left.length==0) ? "No Records Found." : "Loading...", 
					});
					
					//left side scroll bar
					let scrollbar99 = $('.library_list');
					if(scrollbar99.height()>500)
					{
						$('#semana-scroll-inner4').tinyscrollbar();
						$('#semana-scroll-inner4 .scrollbar').show();	
					}
					
					
					//scrollbar99.tinyscrollbar();
               	}



   		 });
               
	}


	componentWillReceiveProps(nextProps) {
			
			// this.getTabs();

		    this.getLibrary('category');
	}


    componentDidMount() {    	

	    	this.getTabs();

		    this.getLibrary(this.state.typeshow);


    }




		render() {
			//alert(this.state.show);
			let left_nav = "";
			let value = 0;
			let contentmsgof=this.state.contentmsg;
			//console.log(contentmsgof);
			if(this.state.leftnav!=null || this.state.leftnav!=undefined) {
			left_nav = this.state.leftnav.map((libleft,i)=>{
				
				let sub_left = '';
				if(libleft.sub_lst != undefined){

					sub_left = libleft.sub_lst.map((sublst,k)=>{

						if(sublst != ''){
							return(
		                              <li  key={`sublst_${k}`} ><a onClick={(e)=>this.getRightlst(sublst.lib_sub_cat_id_pk)} href="javascript:void(0);"   className="libtxt1" >{sublst.lib_subcategory} <span dangerouslySetInnerHTML={{__html:sublst.img}}/></a></li>
								)
						}
					});
				}

				if(libleft != ''){
					 value++;
				return(
						<li key={`leftlst_${i}`}><a href="javascript:void(0);" className={libleft.class} onClick={(e)=>this.getSublists(e)}><span className="list-num">{value}</span>{libleft.cat_name} <span dangerouslySetInnerHTML={{__html:libleft.img}}/></a>
							<ul  className="library_submenu">
							{sub_left}
							 </ul>
						</li>

					)
				}

			});
			}

			let right_nav = '';
			if(this.state.rightnav!=null || this.state.rightnav!=undefined) {
			right_nav = this.state.rightnav.map((rightlst,i)=>{
				let sub_right = '';
				let lib_right = '';
				if(rightlst != ''){

					lib_right = rightlst.sub_lst.map((libright,index)=>{

						if(libright.right != undefined){

							sub_right = libright.right.map((subrightlst,k)=>{

								if(subrightlst != ''){
									if(subrightlst.file_upload!=''){
										let filename = subrightlst.file_upload;
										// let file_type = filename.substr(-3);
										let file_type = filename.split('.').pop();
										//alert(file_type);
										let  file_sent = Config.rootDomainUrl+'admin/library_files/'+filename;
										let new_file = new Buffer(file_sent).toString("base64");
										if(this.state.typeshow == 'video'){
											return(
												<span key={`subrightlst_${k}`}>
												{(file_type == "pdf" || file_type == "jpg" || file_type == "gif" || file_type == "JPG" || file_type == "GIF" )?<li  onClick={()=>this.downFiles(new_file)}><img width="20" src={process.env.PUBLIC_URL+"/images/cat-video-icon.png"}  border="0" align="absmiddle"/><a href="javascript:void(0);" onClick={(e)=>this.updateViews(subrightlst.library_id_pk)} className="liblink" title="Click here to open the file">{subrightlst.name} <span className="orgtxt">{'('+subrightlst.file_size+')'}</span><span dangerouslySetInnerHTML={{__html:subrightlst.img}}/></a></li>:<li  onClick={()=>this.getFiles(subrightlst.file_upload)}><img width="20" src={process.env.PUBLIC_URL+"/images/cat-video-icon.png"}  border="0" align="absmiddle"/><a href="javascript:void(0);" onClick={(e)=>this.updateViews(subrightlst.library_id_pk)} className="liblink" title="Click here to open the file">{subrightlst.name} <span className="orgtxt">{'('+subrightlst.file_size+')'}</span><span dangerouslySetInnerHTML={{__html:subrightlst.img}}/></a></li>}
						                         
						                         {(file_type == 'mp4' || file_type == 'MP4')?<div id="display_vid">{this.state.video}</div>:''}
												 </span>
												 )
										}
										else{
											return(
												<span key={`ssubrightlst_${k}`}>
													<li><a href="javascript:void(0);" onClick={(e)=>this.updateViews(subrightlst.library_id_pk)}  className="liblink">{subrightlst.name}<span dangerouslySetInnerHTML={{__html:subrightlst.img}}/></a></li>
						                         	{(file_type == 'mp4' || file_type == 'MP4')?<div id="display_vid">{this.getMedia(subrightlst.file_upload)}</div>:''}
						                         </span>
											)
										}
									}
									if(subrightlst.external_url!=''){
										
										return(
					                         <li key={`subrightlstk_${k}`}><img width="20" src={process.env.PUBLIC_URL+"/images/cat-video-icon.png"}  border="0" align="absmiddle"/><span onClick={(e)=>this.updateViews(subrightlst.library_id_pk)}><a href={subrightlst.external_url} target="_blank" >{subrightlst.name}<span dangerouslySetInnerHTML={{__html:subrightlst.img}}/></a></span></li>   
										)
									}
									if(subrightlst.content!=''){
										
										return(
					                         <div key={`subrightlstc_${k}`} style={{borderBottom:'1px solid #c9c2b9',float:'left',padding:'0px 0px 10px 0px',width:'100%'}}>
												<a href="javascript:void(0);" onClick={(e)=>this.updateViews(subrightlst.library_id_pk)}><div style={{float:'left',width:'20px',marginRight:'14px'}}><img src={process.env.PUBLIC_URL+"/images/cnt.png"} width="20" height="21" border="0" align="absmiddle"/></div>
												</a>
												<div style={{float:'left'}} className="content-lib"><a href="javascript:void(0);" onClick={()=>this.getContent(subrightlst.content)} className="liblink" title="Click here to read the content">{subrightlst.name}</a></div>
											</div>
										)
									}
									
								}
							});
						}

						if(libright != ''){
							 value++;
						return(
								<div key={`rightlst_${index}`} id={libright.subcat_id} name={libright.subcat_id} style={{display:'none'}} className="cat_right_list">
									<h2 className="cat_head_rgt">{libright.subcat}</h2>
									<section id="semana-scroll-innerr" className={`scrollbar1 semana-scroll-innerr-right_${libright.subcat_id}`}>
									<section className="scrollbar" style={{display:'none'}}>
										<section className="track">
										<section className="thumb"></section>
										</section>
									</section>
									<section className="viewport">
										<section className="overview">
										<div className="cat_right_list" id={`right_scrollof_${libright.subcat_id}`}>
									<ul >
										{sub_right}
									 </ul>
									 </div>
									 </section>
									 </section>
									 </section>
									 
								</div>

							)
						}
					})
				}
				
				return(
					<span key={`rightlstkey_${i}`}>{lib_right}</span>
				)


			});
		}


			return (
					 <section id="contentsection" className="contentarea">
						<div className="inner-title-bg journey-tit-bg">
					        <h1><span><img src={process.env.PUBLIC_URL+"/images/library_img.jpg"} align="absmiddle" alt="" border="0"/></span>Library<br/>
					        <span className="subtitle">Collection of reading materials to expand learning</span></h1>
					     </div>
					     <div className="myobservers">
					        <section id="semana-scroll-inner" className="scrol">
						        <section className="viewport">
						            <section className="overview">
						                <div className="inner-content inner-library-bg">
							                <div className="library_cont">
							                    <div className="library_cat">
								                    <div className="library_cat_left">
								                      <div className="cat_head"> {this.state.catvid} </div>
								                      <section id="semana-scroll-inner4" className="scrollbar1">
								                       <section className="scrollbar" style={{display:'none'}}>
													      <section className="track">
													        <section className="thumb"></section>
													      </section>
													    </section>
													    <section className="viewport">
													      <section className="overview">
													      	<ul  className="library_list gw-nav gw-nav-list" id="leftcont">
															 {(left_nav.length > 0)?left_nav:contentmsgof}
															</ul>
								                           </section>
								                        </section>

								                      </section>

								                     {/*(this.state.show=="show")?<div className="video_lib_link"> <img src={process.env.PUBLIC_URL+"/images/"+this.state.catvidimg} align="absmiddle" alt="" border="0"/>Browse for <a href="javascript:void(0)" onClick={()=>this.getLibrary(this.state.typeshow)}>{this.state.catdown}</a> </div>:<div className=""> </div>*/}
								                    </div>
								                    <div className="library_cat_right">
								                      
								                              {right_nav}
								                             <input type="hidden" value={this.state.id}/>
								                            </div>
								                         
							                    </div>
							                </div>
						                </div>
						            </section>
						        </section>
					        </section>
						</div>
					</section>
			);
		}
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getNewPost}, dispatch);
 
}

export default connect(null,mapDispatchToProps)(Mylibrary);


// WEBPACK FOOTER //
// ./src/learning_resources/library/Mylibrary.js